import VueDraggable from "./VueDraggable/index.vue";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const install = (Vue) => {
  Vue.component("VueDraggable", VueDraggable);
};

export default {
  install,
  VueDraggable,
};
